if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.etMobileReady = false;
      }

      hide() {
        this.etResetAllZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.etInitMobileViewer();
        requestAnimationFrame(() => this.etUpdateMobileViewer());
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => element.classList.remove('active'));

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = Math.max(0, (activeMedia.offsetLeft || 0));

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) activeMedia.loadContent();
      }

      etSlides() {
        const content = this.querySelector('.product-media-modal__content');
        return content ? Array.from(content.children).filter((el) => el.hasAttribute('data-media-id')) : [];
      }

      etCurrentIndex() {
        const content = this.querySelector('.product-media-modal__content');
        const slides = this.etSlides();
        if (!content || !slides.length) return 0;
        const center = content.scrollLeft + content.clientWidth / 2;
        let best = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const d = Math.abs(slideCenter - center);
          if (d < distance) { distance = d; best = index; }
        });
        return best;
      }

      etGo(delta) {
        const slides = this.etSlides();
        if (!slides.length) return;
        const current = this.etCurrentIndex();
        const next = Math.max(0, Math.min(slides.length - 1, current + delta));
        if (next === current) return;
        this.etResetAllZoom();
        slides[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        window.setTimeout(() => this.etUpdateMobileViewer(), 260);
      }

      etUpdateMobileViewer() {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const slides = this.etSlides();
        const index = this.etCurrentIndex();
        const counter = this.querySelector('[data-et-modal-counter]');
        const prev = this.querySelector('[data-et-modal-prev]');
        const next = this.querySelector('[data-et-modal-next]');
        if (counter) counter.textContent = slides.length ? `${index + 1} / ${slides.length}` : '';
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= slides.length - 1;
      }

      etResetAllZoom() {
        this.querySelectorAll('.product-media-modal__content img[data-et-mobile-zoom]').forEach((img) => {
          img._etScale = 1;
          img._etX = 0;
          img._etY = 0;
          img.style.transform = '';
          img.style.transition = '';
          img.closest('[data-media-id]')?.classList.remove('et-is-zoomed');
        });
      }

      etInitImageZoom(img) {
        if (img.dataset.etMobileZoom === 'true') return;
        img.dataset.etMobileZoom = 'true';
        img._etScale = 1; img._etX = 0; img._etY = 0;
        let pinchStartDistance = 0, pinchStartScale = 1;
        let panStartX = 0, panStartY = 0, panOriginX = 0, panOriginY = 0;
        let lastTap = 0;
        const slide = img.closest('[data-media-id]');

        const apply = (animate = false) => {
          img._etScale = Math.max(1, Math.min(4, img._etScale || 1));
          if (img._etScale <= 1.01) { img._etScale = 1; img._etX = 0; img._etY = 0; }
          const maxX = Math.max(0, (img.clientWidth * img._etScale - img.clientWidth) / 2);
          const maxY = Math.max(0, (img.clientHeight * img._etScale - img.clientHeight) / 2);
          img._etX = Math.max(-maxX, Math.min(maxX, img._etX || 0));
          img._etY = Math.max(-maxY, Math.min(maxY, img._etY || 0));
          img.style.transition = animate ? 'transform .2s ease' : 'none';
          img.style.transform = img._etScale === 1 ? '' : `translate3d(${img._etX}px,${img._etY}px,0) scale(${img._etScale})`;
          slide?.classList.toggle('et-is-zoomed', img._etScale > 1);
        };

        const distance = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);

        img.addEventListener('touchstart', (e) => {
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          if (e.touches.length === 2) {
            e.preventDefault();
            pinchStartDistance = distance(e.touches[0], e.touches[1]);
            pinchStartScale = img._etScale || 1;
          } else if (e.touches.length === 1 && (img._etScale || 1) > 1) {
            e.preventDefault();
            panStartX = e.touches[0].clientX; panStartY = e.touches[0].clientY;
            panOriginX = img._etX || 0; panOriginY = img._etY || 0;
          }
        }, { passive: false });

        img.addEventListener('touchmove', (e) => {
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          if (e.touches.length === 2 && pinchStartDistance) {
            e.preventDefault();
            img._etScale = pinchStartScale * (distance(e.touches[0], e.touches[1]) / pinchStartDistance);
            apply(false);
          } else if (e.touches.length === 1 && (img._etScale || 1) > 1) {
            e.preventDefault();
            img._etX = panOriginX + (e.touches[0].clientX - panStartX);
            img._etY = panOriginY + (e.touches[0].clientY - panStartY);
            apply(false);
          }
        }, { passive: false });

        img.addEventListener('touchend', () => {
          pinchStartDistance = 0;
          if ((img._etScale || 1) < 1.08) { img._etScale = 1; apply(true); }
        }, { passive: true });

        img.addEventListener('click', (e) => {
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          const now = Date.now();
          if (now - lastTap < 320) {
            e.preventDefault(); e.stopPropagation();
            img._etScale = (img._etScale || 1) > 1 ? 1 : 2;
            img._etX = 0; img._etY = 0; apply(true);
            lastTap = 0;
          } else lastTap = now;
        });
      }

      etInitMobileViewer() {
        if (this.etMobileReady) return;
        this.etMobileReady = true;
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        this.querySelector('[data-et-modal-prev]')?.addEventListener('click', () => this.etGo(-1));
        this.querySelector('[data-et-modal-next]')?.addEventListener('click', () => this.etGo(1));
        content.addEventListener('scroll', () => {
          window.clearTimeout(this._etScrollTimer);
          this._etScrollTimer = window.setTimeout(() => this.etUpdateMobileViewer(), 80);
        }, { passive: true });
        content.querySelectorAll('img').forEach((img) => this.etInitImageZoom(img));
      }
    }
  );
}
